export default __webpack_public_path__ + "static/media/PurchaseLinkIndicatorCustomiseActive.726a1810.svg";